export function formatBalance(balance: number | string): string {
    if (typeof balance === "string") {
        balance = Number.parseFloat(balance);
    }
    let formattedBalance = "";
    if (balance >= 1000) {
        formattedBalance = balance.toFixed(0);
        return Number.parseFloat(formattedBalance).toLocaleString();
    } else if (balance >= 1) {
        formattedBalance = balance.toFixed(2);
        return Number.parseFloat(formattedBalance).toLocaleString();
    } else if (balance >= 0.01) {
        formattedBalance = balance.toFixed(3);
    } else if (balance >= 0.001) {
        formattedBalance = balance.toFixed(4);
    } else if (balance >= 0.0001) {
        formattedBalance = balance.toFixed(5);
    } else if (balance >= 0.00001) {
        formattedBalance = balance.toFixed(6);
    } else if (balance < 0.00001 ) {
        formattedBalance = balance.toFixed(7);;
    }
    return formattedBalance;
}

